import { Messages } from '../../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../../settings/services/ServerSettingsUnauthenticated';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { siteUserResetLoginRateLimiting } from '../../../actions/spaces/SiteUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSelectingSomethingOtherThanGuest } from './IEntityActionHelpers';

export const SiteUserResetLoginRateLimitingAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserResetLoginRateLimiting,
  translateName: Messages.resetLoginRateLimiting_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthLoginRateLimitingEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return isSelectingSomethingOtherThanGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserResetLoginRateLimiting(targetItems)
};
